import convertTone from 'pinyin-tone-convert';
import isEmpty from 'lodash/isEmpty';
import { censorBadWords } from './utils/censor-bad-words';

export class ZhongwenDictionary {
  constructor(wordDict, wordIndex, grammarKeywords) {
    this.wordDict = wordDict;
    this.wordIndex = wordIndex;
    this.grammarKeywords = grammarKeywords;
    this.cache = {};
  }

  static find(needle, haystack) {
    let beg = 0;
    let end = haystack.length - 1;

    while (beg < end) {
      let mi = Math.floor((beg + end) / 2);
      let i = haystack.lastIndexOf('\n', mi) + 1;

      let mis = haystack.substr(i, needle.length);
      if (needle < mis) {
        end = i - 1;
      } else if (needle > mis) {
        beg = haystack.indexOf('\n', mi + 1) + 1;
      } else {
        return haystack.substring(i, haystack.indexOf('\n', mi + 1));
      }
    }

    return null;
  }

  hasKeyword(keyword) {
    return this.grammarKeywords[keyword];
  }

  wordSearch(word, max) {
    let entry = { data: [] };

    let dict = this.wordDict;
    let index = this.wordIndex;

    let maxTrim = max || 10;

    let count = 0;
    let maxLen = 0;

    WHILE: while (word.length > 0) {
      let ix = this.cache[word];
      if (!ix) {
        ix = ZhongwenDictionary.find(word + ',', index);
        if (!ix) {
          this.cache[word] = [];
          continue;
        }

        ix = ix.split(',');
        this.cache[word] = ix;
      }

      for (let j = 1; j < ix.length; ++j) {
        let offset = ix[j];

        let dentry = dict.substring(offset, dict.indexOf('\n', offset));

        if (count >= maxTrim) {
          entry.more = 1;
          break WHILE;
        }

        ++count;
        if (maxLen === 0) {
          maxLen = word.length;
        }

        entry.data.push([censorBadWords(dentry), word]);
      }

      word = word.substr(0, word.length - 1);
    }

    if (entry.data.length === 0) return null;

    entry.matchLen = maxLen;

    return entry;
  }

  parseResults(results) {
    let filteredDictWords = [];
    let traditionalChar = null;

    results.forEach((result) => {
      const dictWord = this.parseResult(result);

      if (!dictWord) {
        return;
      }

      const { traditional } = dictWord;

      traditionalChar = traditionalChar ?? traditional[0];

      // filter out results such as 'x is an old variant of y' as most as possible
      if (traditional.length > 1 || traditionalChar === traditional) {
        filteredDictWords.push(dictWord);
      }
    });

    return filteredDictWords;
  }

  parseResult([result, text]) {
    const resultRegExp = /^(?<traditional>.+) (.+) \[(?<pinyin>[^\]]+)\] \/(?<definition>.+)\/\r?$/;

    const match = result.match(resultRegExp);
    const { traditional, pinyin, definition } = match.groups;

    const parsed = {
      text,
      traditional,
      pinyin: parsePinyin(pinyin),
      definition: parseDefinition(definition),
    };

    if (isDefinitionCensored(parsed.definition)) {
      return null;
    }

    return parsed;
  }
}

export const parsePinyin = (pinyin) => {
  return convertTone(pinyin.replace(/u:/g, '\u00FC'));
};

export const parseDefinition = (definition) => {
  return (
    definition
      // strip out all slangs/intensifier
      .replace(/(^|\/)[^/]*\((slang|intensifier|vulgar)\).+$/g, '')
      .replace(/\/$/, '')
      .replace(/\//g, '; ')
  );
};

const isDefinitionCensored = (definition) => {
  if (isEmpty(definition)) {
    return true;
  }

  const censoredRegexps = [/^(\w+ )?variant of/];
  return censoredRegexps.some((regexp) => !!definition.match(regexp));
};
